import React from 'react';
import MuiGridList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

const styles = theme => ({
    root: {
        margin: '-2px',
    },
    gridList: {
        width: '100%',
        margin: 0,
    },
    tileBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.4) 70%,rgba(0,0,0,0) 100%)',
    },
    placeholder: {
        backgroundColor: theme.palette.grey[300],
        height: '100%',
    },
    price: {
        display: 'inline',
        fontSize: '1em',
    },
    link: {
        color: '#fff',
    },
});

const getColsForWidth = width => {
    if (width === 'xs') return 2;
    if (width === 'sm') return 3;
    if (width === 'md') return 4;
    if (width === 'lg') return 5;
    return 6;
};

const times = (nbChildren, fn) =>
    Array.from({ length: nbChildren }, (_, key) => fn(key));

const LoadingGridList = ({ width, classes, nbItems = 10 }) => (
    <div className={classes.root}>
        <MuiGridList
            cellHeight={180}
            cols={getColsForWidth(width)}
            className={classes.gridList}
        >
            {' '}
            {times(nbItems, key => (
                <ImageListItem key={key}>
                    <div className={classes.placeholder} />
                </ImageListItem>
            ))}
        </MuiGridList>
    </div>
);

const LoadedGridList = ({ classes, ids, data, basePath, width }) => {

    // componentDidMount() {
    //     console.log('I was triggered during componentDidMount')
    //     console.log(data);
    // }
    
    return (

        <div className={classes.root}>
            <MuiGridList
                cellHeight={180}
                cols={getColsForWidth(width)}
                className={classes.gridList}
            >
                {ids.map(id => (
                // data[id] != null ? (

                    <ImageListItem
                        component={Link}
                        key={id}
                        to={linkToRecord(basePath, data[id].id)}
                    >
                        
                        {
                            data[id].thumbnail_2x != null ? (
                                <img src={data[id].thumbnail_2x.url} alt="" />      
                            ) : null
                        }

                        <ImageListItemBar
                            className={classes.tileBar}
                            title={data[id].name}
                        />

                    </ImageListItem>
                    //) : null

                ))}
            </MuiGridList>
        </div>

    );
};

const TemplateGridList = ({ loaded, ...props }) =>
loaded ? <LoadedGridList {...props} /> : <LoadingGridList {...props} />;

// const enhance = compose(
//     withWidth(),
//     withStyles(styles)
// );

export default TemplateGridList;